import { withNamespaces } from 'react-i18next';
import {
    Button,
    Card,
    CardBody,
    Col,
    Row,
} from 'reactstrap';

import { BidDocumentStatuses } from '../constants';

const DocumentEvidence = ({
    documents = [],
    showAddDocument,
    addDocumentLabel,
    t,
}) => {
    return (
        <Card>
            <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">
                        {t('Document evidence')}
                        <span className="badge badge-soft-secondary ms-2">{documents.length}</span>
                    </h5>
                    <Button className="p-0" color="link" size="sm" type="button">
                        {t('View all')}
                    </Button>
                </div>

                <Row>
                    {documents.map((document) => {
                        const statusInfos = BidDocumentStatuses[document.status];

                        return (
                            <Col key={document.id} sm="6" xl="3">
                                <div className="border rounded p-2 h-100 mb-2">
                                    <img
                                        alt={document.title}
                                        className="img-fluid rounded mb-2"
                                        src={document.preview}
                                    />
                                    <small className="d-block text-truncate">{t(document.title)}</small>
                                    <small className={statusInfos.className}>
                                        <i className={`${statusInfos.icon} align-middle me-1`} />
                                        {t(statusInfos.title)}
                                    </small>
                                </div>
                            </Col>
                        );
                    })}

                    {showAddDocument && (
                        <Col sm="6" xl="3">
                            <div className="border rounded p-2 h-100 mb-2 d-flex flex-column justify-content-center align-items-center text-muted">
                                <i className="ri-upload-cloud-2-line font-size-24" />
                                <small className="text-center">{t(addDocumentLabel || 'Add document')}</small>
                            </div>
                        </Col>
                    )}
                </Row>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    DocumentEvidence
);
